import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import React, { useRef, useState } from 'react';
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import { Trans, useTranslation } from 'react-i18next';
import AuthenticationService from '../service/AuthenticationService';
import AuthService from '../security/AuthService';
import { useNavigate } from 'react-router-dom';
import { classNames } from 'primereact/utils';
import { Chip } from 'primereact/chip';
import { Badge } from 'primereact/badge';
import { Avatar } from 'primereact/avatar';

import { StyleClass } from 'primereact/styleclass';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import FileService from '../service/FileService';
import { Dialog } from 'primereact/dialog';
import CustomUpdate from './CustomUpdate';


const CustomAuthLayer = (props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [displayLoadingDialog, setDisplayLoadingDialog] = useState(false);

    const btnRef1 = useRef(null);
    const btnRef2 = useRef(null);
    const menubutton = useRef(null);
    const menubuttonRef = useRef(null);

    const [updateVisible, setUpdateVisible] = useState(false);


    const onLogout = async (event) => {

        console.log('onLogout');
        await AuthService.doLogout();
        event.preventDefault();
        navigate('/');
        props.op&&props.op.current&&props.op.current.hide();
        


    }

    const onClick = (param) => {

        console.log("onClick", param)

    }

    


    const updateLayer = () => {
        return (
            <Dialog showCloseIcon closeOnEscape dismissable={false} visible={updateVisible} position={'top'} onHide={() => setUpdateVisible(false)} className={'search-dialog'} headerClassName='search-dialog-header' contentClassName='search-dialog-content' >

                <CustomUpdate toast={props.toast} 

                ></CustomUpdate>




            </Dialog>

        )


    }


    const layer = () => {
        return (
            <div className="surface-section" >
                <div className="user-bg-section"
                    style={{
                        backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1)),  url(  ${ AuthService.getHeaderImage()!="undefined"? FileService.inquireFilePath(AuthService.getHeaderImage()):"/assets/layout/images/bg/user_bg.png"} )`,
                        backgroundRepeat: "no-repeat",

                        backgroundSize: "cover",

                    }}>
                    <div className="user-bg-section-above flex align-items-center justify-content-center">
                        <div style={{

                            color: '#ffffff',
                            textAlign: 'center',
                            display: 'flex',
                            justifyContent: 'center',
                            flexDirection: 'column', // inner items will be added vertically
                            backgroundColor: "gray",
                            height: 40,
                            width: 40,
                            borderRadius: 20,
                            backgroundImage: `url(${AuthService.getProfileImage()!="undefined"?FileService.inquireFilePath(AuthService.getProfileImage()):"/assets/layout/images/profile-image.png"})`,
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "cover",


                        }}></div>
                        <div className="w-8  align-items-left ml-2"  >
                            <div className="text-0  w-12 font-normal flex align-items-center font-white" >
                                {AuthService.getFullName()}
                                {AuthService.hasBluetick() === 1 &&
                                    <div
                                        className="blue-check-point ml-1 mt-1"  >
                                        <i className="fas fa-check" style={{ fontSize: '12px' }} ></i>


                                    </div>
                                }
                            </div>
                            <div className="text-50  w-12  font-normal  font-white" >
                                {AuthService.getUserName()? ("("+AuthService.getUserName()+")"):""}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="topbar-menu">
                    <ul className="topbar-menu active-topbar-menu p-2 pl-4 pr-4 z-5 border-round" style={{ listStyle: "none" }}>
                        <li role="menuitem" className="m-0 mb-3">
                            <a href={"/profile/" + AuthService.getUserId() + "/" + AuthService.getUserType()} ref={menubutton} className="flex align-items-center hover:text-gray-400 transition-duration-200">
                                <i className="fas fa-user-large"></i>
                                <span className='ml-2'> {t('global_text_viewing_profile')}</span>
                            </a>
                        </li>
                        <li role="menuitem" className="m-0 mb-3">
                            <a href="/favorites" ref={menubutton} className="flex align-items-center hover:text-gray-400 transition-duration-200">
                                <i className="fas fa-heart"></i>
                                <span className='ml-2'> {t('global_text_viewing_history')}</span>
                            </a>
                        </li>
                        <li role="menuitem" className="m-0 mb-3">
                            <a href={"/exhibit/" + AuthService.getUserId() } ref={menubutton} className="flex align-items-center hover:text-gray-400 transition-duration-200">
                                <i className="fas fa-images"></i>
                                <span className='ml-2'> {t('global_text_viewing_exhibitions')}</span>
                            </a>
                        </li>
                        <li role="menuitem" className="m-0 mb-3">
                                               
                            <button className="p-link flex align-items-center hover:text-gray-400 transition-duration-200" onClick={()=>setUpdateVisible(true)}>
                            <i className="fas fa-gear"></i>

                                    <span className='ml-2'> {t('global_text_settings')}</span>
                                </button>
                        </li>

                        <li role="menuitem" className="pt-3 border-top-1 " style={{ borderTopColor: "#989D98" }}>
                            <div className="text-0  w-12 font-normal flex align-items-center justify-content-between" >

                                <button className="p-link flex align-items-center hover:text-gray-400 transition-duration-200" onClick={onLogout}>
                                    <i className="fas fa-right-from-bracket"></i>

                                    <span className='ml-2'> {t('profile_logout')}</span>
                                </button>
                                {
                                    AuthService.checkPermission("account_management") ?
                                        <a href="/admin/accountmanagement" ref={menubuttonRef} className="flex align-items-center hover:text-gray-400 transition-duration-200 pr-2" >
                                            <i className="fas fa-screwdriver-wrench"></i>
                                        </a> : <div></div>
                                }


                            </div>
                        </li>
                    </ul>
                </div>

            </div >
        )
    }



    return (
        <div style={{
            ...props.containerStyle,
            width: "100%",
            borderRadius: 20,


        }}>
            {layer()}
        {updateLayer()}
        </div>
    )
}

export default CustomAuthLayer;
